import {
    DOWNLOADINVOICE_FAIL,
    DOWNLOADINVOICE_SUCCESS,
} from '../actionTypes';

const initialState = {
    user: null
};

const downloadInvoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case DOWNLOADINVOICE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case DOWNLOADINVOICE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default downloadInvoiceReducer;
